import { render, staticRenderFns } from "./Coverage.vue?vue&type=template&id=5e50a99d&scoped=true"
import script from "./Coverage.vue?vue&type=script&lang=js"
export * from "./Coverage.vue?vue&type=script&lang=js"
import style0 from "./Coverage.vue?vue&type=style&index=0&id=5e50a99d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e50a99d",
  null
  
)

export default component.exports